module.exports = __webpack_public_path__ + "static/media/medal.808a2141.svg";